// Medal/badge thresholds for Norwegian shooting programs.
// Extracted from webapp/src/components/convention/view.js to share between
// the convention page and the feed-recap helper.
export function getOfficialMark(score, shootingClass, stageType) {
    if (!score || score === 0) return null;

    // NAIS 30 shots thresholds
    if (stageType === 'nais') {
        // 25 m fin thresholds
        const finThresholds = [
            { min: 260, label: 'GM', color: '#FFD700', title: 'Gull medalje' },
            { min: 250, label: 'SM', color: '#C0C0C0', title: 'Sølv medalje' },
            { min: 240, label: 'BM', color: '#CD7F32', title: 'Bronse medalje' },
            { min: 220, label: 'G', color: '#FFD700', title: 'Gullmerke' },
            { min: 210, label: 'S', color: '#C0C0C0', title: 'Sølvmerke' },
            { min: 200, label: 'B', color: '#CD7F32', title: 'Bronsemerke' },
        ];

        // 25 m grov / 10 m luft thresholds
        const grovLuftThresholds = [
            { min: 240, label: 'GM', color: '#FFD700', title: 'Gull medalje' },
            { min: 230, label: 'SM', color: '#C0C0C0', title: 'Sølv medalje' },
            { min: 220, label: 'BM', color: '#CD7F32', title: 'Bronse medalje' },
            { min: 200, label: 'G', color: '#FFD700', title: 'Gullmerke' },
            { min: 190, label: 'S', color: '#C0C0C0', title: 'Sølvmerke' },
            { min: 180, label: 'B', color: '#CD7F32', title: 'Bronsemerke' },
        ];

        const thresholds = shootingClass === 'fin' ? finThresholds : grovLuftThresholds;

        for (const threshold of thresholds) {
            if (score >= threshold.min) {
                return threshold;
            }
        }
    }

    // Hurtig 25m thresholds
    if (stageType === 'hurtig') {
        // 25 m hurtigpistol fin thresholds (used for all classes)
        const hurtigThresholds = [
            { min: 583, label: 'GM', color: '#FFD700', title: 'Gull medalje' },
            { min: 575, label: 'SM', color: '#C0C0C0', title: 'Sølv medalje' },
            { min: 545, label: 'BM', color: '#CD7F32', title: 'Bronse medalje' },
        ];

        for (const threshold of hurtigThresholds) {
            if (score >= threshold.min) {
                return threshold;
            }
        }
    }

    // T-96 Kråkefelt — TBD: confirm thresholds with NSF / discipline rules.
    if (stageType === 't-96') {
        return null;
    }

    return null;
}

export default getOfficialMark;
